<template>
    <div class="quiz-menu">
        <div class="quiz-menu__header tw:font-bold!">Quick Navigation</div>

        <ul>
            <li v-for="item in questions" :key="item.display_order" class="quiz-menu__item">
                <a @click="open(item.display_order)" @keyup="open(item.display_order)">
                    Question {{ Number(item.display_order) + 1 }}
                </a>
            </li>
        </ul>
    </div>
</template>

<script>
export default {
    name: 'QuizMenu',

    props: {
        uuid: {
            required: true,
            type: [String, Number],
        },
    },

    data: () => ({
        options: {
            container: '#quiz-builder',
            easing: 'ease-in',
            offset: -110,
            force: true,
            cancelable: true,
            onCancel() {},
            x: false,
            y: true,
        },
    }),

    computed: {
        questions() {
            return this.$store.getters[`QuizBuilder/${this.uuid}/get`]('questions');
        },
    },

    mounted() {
        const element = document.getElementsByClassName('quiz-builder-modal');

        element[0].setAttribute('id', 'quiz-builder');
    },

    methods: {
        get(field, order) {
            return this.$store.getters[`QuizBuilder/${this.uuid}/question`]({
                order,
                field,
            });
        },

        open(order) {
            const element = `#Question-${order}`;

            this.$scrollTo(element, 500, this.options);

            this.$store.dispatch(`QuizBuilder/${this.uuid}/setQuestionField`, {
                field: 'expanded',
                order,
                value: true,
            });
        },
    },
};
</script>

<style lang="scss">
@import 'resources/scss/toolbox.scss';

.quiz-menu {
    position: sticky;
    position: -webkit-sticky;
    top: $size-4;

    &__header {
        color: $text;
        font-size: 0.9em !important;
        font-weight: $weight-semibold;
        letter-spacing: 0.05rem;
        line-height: 1.66667;
        padding: 0.375rem 0;
        text-transform: uppercase;
    }

    &__item {
        a {
            border-radius: 0;
            color: $text;
            display: block;
            padding: 0.375em 0;
        }
    }
}
</style>
